import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './CreatorMarquee.css';

// Import creator images
import creator1 from '../assets/creators/creator1.png';
import creator2 from '../assets/creators/creator2.png';
import creator3 from '../assets/creators/creator3.png';
import creator4 from '../assets/creators/creator4.png';
import creator5 from '../assets/creators/creator5.png';
import creator6 from '../assets/creators/creator6.png';

const CREATORS = [
  { id: 1, name: 'AMBER QUINN', followers: '2.2M', image: creator1, link: 'https://t.me/amberquinnn' },
  { id: 2, name: 'MORGAN KETZNER', followers: '1.1M', image: creator2, link: 'https://t.me/morganketznerr' },
  { id: 3, name: 'ABBY RAO', followers: '2.2M', image: creator3, link: 'https://t.me/theabbyrao' },
  { id: 4, name: 'NATASHA ELECTRA', followers: '1.2M', image: creator4, link: 'https://t.me/natashaelectra' },
  { id: 5, name: 'KRISTINA LEVINA', followers: '673K', image: creator5, link: 'https://t.me/le_xtinaa' },
  { id: 6, name: 'ANTHIA MO', followers: '1.1M', image: creator6, link: 'https://t.me/anthiamo_official' },
];

// Triple the creators array for smooth infinite scroll
const TRIPLED_CREATORS = [...CREATORS, ...CREATORS, ...CREATORS];

const CreatorMarquee = () => {
  const scrollRef = useRef(null);
  const marqueeAnimation = useRef(null);

  useEffect(() => {
    const itemWidth = 180 + 24; // width + gap
    const totalWidth = CREATORS.length * itemWidth;
    
    // Set initial position
    gsap.set(scrollRef.current, { x: 0 });

    // Create the marquee animation
    marqueeAnimation.current = gsap.timeline({
      repeat: -1,
      defaults: { ease: 'none' }
    })
    .to(scrollRef.current, {
      x: -totalWidth,
      duration: CREATORS.length * 5,
      ease: 'none',
    })
    .to(scrollRef.current, {
      x: 0,
      duration: 0,
    });

    // Cleanup
    return () => {
      if (marqueeAnimation.current) {
        marqueeAnimation.current.kill();
      }
    };
  }, []);

  const handleCreatorClick = (link) => {
    window.open(link, '_blank');
  };

  return (
    <div className="marquee-container">
      <div className="marquee-inner" ref={scrollRef}>
        {TRIPLED_CREATORS.map((creator, index) => (
          <div
            key={`${creator.id}-${index}`}
            className="marquee-item"
            onClick={() => handleCreatorClick(creator.link)}
          >
            <div 
              className="creator-image" 
              style={{ backgroundImage: `url(${creator.image})` }}
            >
              <div className="creator-info">
                <span className="creator-name">{creator.name}</span>
                <div className="creator-stats">
                  <img src="/instagram-white.svg" alt="Instagram" className="creator-instagram" />
                  <span className="creator-followers">{creator.followers}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreatorMarquee; 